import React, { useEffect, useContext, useState, useMemo } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  formatPrice,
  getSystemSettings,
  customStyle,
  customError,
  validateItemsProperty
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//pages & includes
import ManageSidebar from "../ManageSidebar";
import './stock.css'

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { SettingsContext } from "../../../../../contexts/Settings";
import { max } from "moment";

const IngredientPurchaseEdit = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const params = useParams();
  const search = useLocation().search;
  const duplicate = new URLSearchParams(search).get('duplicate');
  const { roundOffStock, qtyAmountPoints} = useCustomHooks();
  //getting context values here
  let {
    loading,
    setLoading,
    branchForSearch,
    getIngredientItem,
    ingredientItemNonPurchase,
    ingredientLimitCheck,
    getIngredientLimit,
    dataPaginating,
  } = useContext(RestaurantContext);
  let { getSupplier, supplierForSearch, authUserInfo } = useContext(UserContext);
  const { generalSettings } = useContext(SettingsContext);
  // States hook here
  //new item
  let [newItem, setNewItem] = useState({
    branch: null,
    supplier: null,
    transportation: 0,
    invoice: "",
    ref_doc_identity: null,
    is_ref_no: 0,
    description: "",
    paymentType: "cash",
    document: "",
    items: [],
    paid: null,
    total: null,
    item_amount: 0,
    item_dis: 0,
    item_tax: 0,
    manual_invoice_no: "",
    credit_limit_days: "",
  });
  const [GRNDetail,setGRNDetail] = useState([]);
  //new Row
  const [newRow,setNewRow]=useState([]);
  //edit account
  const [editPurchase,setEditPurchase]=useState(null);
  
  //datepicker
  const [purchaseDate, setPurchaseDate] = useState(new Date());

  const { piDiscountFixed, piTaxFixed, piBackDate } = useMemo(()=>{
    return {
      piDiscountFixed: parseInt(getSystemSettings(generalSettings, "pi_discount")) === 1,
      piTaxFixed: parseInt(getSystemSettings(generalSettings, "pi_tax")) === 1,
      piBackDate: parseInt(getSystemSettings(generalSettings, "pi_back_date")) === 1
    } 
  },[generalSettings]);

  //Get Specific item for edit
  const getPurchasedItem = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-ingredient_purchase_items/" + parseInt(params.id);
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });        
        if(res){
          setEditPurchase(res.data)
        }         
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };
      
  //useEffect == componentDidMount()
  useEffect(() => {
    if(!supplierForSearch){
      getSupplier();
    }
    if(!ingredientItemNonPurchase){
      getIngredientItem()
    }

    if(!ingredientLimitCheck){
      getIngredientLimit()
    }
   
    if(params.id){
      getPurchasedItem();
    }

  }, []);
      
  useEffect(()=>{
    if(editPurchase && editPurchase !== null){
      let docDate=new Date(editPurchase[1].purchase_date);
      let branch=branchForSearch?.find((item)=>editPurchase[1].branch_id === item.id)
      let suppAcc=supplierForSearch?.find((item)=>editPurchase[1].supplier_id === item.id);
     
      setNewItem({
        ...newItem,
        invoice:editPurchase[1].invoice_number,
        branch,
        ref_doc_identity: !duplicate && editPurchase[1].ref_doc_identity ? {document_identity: editPurchase[1].ref_doc_identity} : null,
        is_ref_no: 0,
        supplier:suppAcc,
        transportation: editPurchase[1].transportation,
        paymentType:editPurchase[1].payment_type,
        description:editPurchase[1]?.desc ?? "",
        credit_limit_days:editPurchase[1].credit_limit_days ?? "",
        manual_invoice_no:editPurchase[1].manual_invoice_no ?? "",
        document: editPurchase[1]?.pi_document ?? "",
      })
      setPurchaseDate(docDate);
      let rowArr=[];
      if(editPurchase[0] && editPurchase[0].length > 0){
        editPurchase[0].map((item)=>{
          const maxLimit = ingredientLimitCheck?.igs?.[editPurchase[1].branch_id]?.[item.ingredient_id]?.max_limit;
          rowArr.push({
            item_id: item.ingredient_id,
            item_name: item.ingredient_name,
            ref_doc_identity: item?.ref_doc_identity || "",
            qty:item.qty,
            unitId:item.unit_id,
            max_qty: branch?.max_pi_qty_check && maxLimit ? (maxLimit ?? 0) : "",
            unit:item.unit_name,
            rate: roundOffStock(item.rate),
            amount: roundOffStock(item.total_amount),
            discount_percent: roundOffStock(item.discount_percent),
            discount: roundOffStock(item.discount),
            tax_percent: roundOffStock(item.tax_percent),
            tax: roundOffStock(item.tax), 
            advance_tax_percent: roundOffStock(item.advance_tax_percent) ?? 0,
            advance_tax: roundOffStock(item.advance_tax) ?? 0,
            total: roundOffStock(item.total),
            base_unit:item.base_unit,
            base_qty: roundOffStock(item.base_qty),
            conversion_qty: roundOffStock(item.conversion_qty),
            base_price: roundOffStock(item.base_price),
            isEdit:true,
          })
        })
        setNewRow([...rowArr]);
      }
    }
  },[editPurchase,supplierForSearch,branchForSearch])

  //grn order item
  const getGRNItem = async(branch, supplier) =>{
    try{
      const url = BASE_URL + "/settings/get-grn-items/" + branch?.id + "/" + supplier.id;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        setNewRow([])
        setGRNDetail(res.data)
      }
    }catch(err){
      toast.error(`${_t(t("Please try again later"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }

  const setGRNItem = (data)=>{
    setNewItem({...newItem, ref_doc_identity: data});
    if(data){
      if(newRow?.length){
        let valid = false;
        valid = newRow.find((item)=> item.ref_doc_identity === data.document_identity);
        if(valid){
          toast.error(`${_t(t("GRN already exist"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          })
          return
        }
      }
      if(data?.goods_received_note_detail && data.goods_received_note_detail.length>0){
        let slugArr= newItem.is_ref_no ? [...newRow] : [];;
        data.goods_received_note_detail.map((item,index)=>{
          slugArr.push({
            ...item,
            ref_doc_identity: data?.document_identity,
            unitId:item.unit_id,
            unit:item.unit_name,
            isEdit:true,
          })
        })
        setNewRow([...slugArr]);
      }
    }else{
      setNewRow([]);
    }
  }

  //set image hook
  const handleItemImage = (e) => {
    setNewItem({
      ...newItem,
      [e.target.name]: e.target.files[0],
    });
    if (document.getElementById([e.target.name])) {
      document.getElementById([e.target.name]).value = '';
    }
  };

  //on change input field
  const handleChange = (e) => {
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };

  //set items hook
  const handleSetItems = async (index,item) => {
    newRow[index].unit="";
    newRow[index].base_unit="";
    newRow[index].base_qty="";
    newRow[index].conversion_qty="";
    newRow[index].item_name=item;
    newRow[index].base_unit=item.unit_id;
    newRow[index].item_units="";
    newRow[index].rate= Number(item.price) || 0;
    newRow[index].max_qty = "";
    setNewRow([...newRow]);
    getUnits(item.id,index)
  };

  const getUnits=async(id,index)=>{
    const url = BASE_URL + "/settings/get-unit_item/"+ id;
    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
    .then((res) => {      
      if(res.data){        
        newRow[index].item_units = res.data;
        newRow[index].unit= res.data[1] ?? "";
        newRow[index].conversion_qty= res.data[1]?.qty ?? "";
        if(newItem.branch?.max_pi_qty_check){
          const maxLimit = ingredientLimitCheck?.igs?.[newItem.branch?.id]?.[id]?.max_limit;
          if(maxLimit){
            newRow[index].max_qty = (maxLimit ?? 0);
          }
        }
        setNewRow([...newRow]);
      }      
    }).catch((error) =>{
      console.log("check error",error);
    })
  }

  const handleSetUnit=(index,unit)=>{    
    newRow[index].unit=unit;
    newRow[index].conversion_qty=unit.qty;
    setNewRow([...newRow]);
  }

  const calBaseQty=(index)=>{
    let qty=newRow[index].qty;
    let conversion_qty=newRow[index].conversion_qty
    if(qty && conversion_qty){
      return roundOffStock(qty * conversion_qty);
    }else{
      return "";
    }
  }

  const calBasePrice=(index)=>{
    let amount = handleGetAmount(index);
    let baseQty = calBaseQty(index);
    if(amount && baseQty){
      return roundOffStock(amount/baseQty);
    }else{
      return 0;
    }
  }
  
  const addNewRow=()=>{ 
    setNewRow((pre)=>[...pre,{
      item_name:"",
      ref_doc_identity: "",
      qty:"",
      unit:"",
      rate:"",
      amount:"",
      discount_percent:"",
      discount:0,
      tax_percent:"",
      tax:0, 
      advance_tax_percent:"",
      advance_tax:0,
      total:"",
      base_unit:"",
      base_qty:"",
      max_qty: "",
      conversion_qty:"",
      isEdit:false,
    }])    
  }

  const delRow=(id)=>{
    let row=[...newRow]
    row.splice(id, 1);
    setNewRow(row);
  }

  //subtotal
  const handleGetSubTotal = (index) => {
    let qty = 0;
    let rate = 0;
    let tax = 0;
    let discount = 0;

    let advance_tax = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].rate  !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    if (newRow !== null && (newRow[index]?.tax || newRow[index]?.tax_percent)) {
      tax = piTaxFixed ? (Number(newRow[index].tax) || 0) : handleTaxItem(index);
    }
    if (newRow !== null && (newRow[index]?.advance_tax || newRow[index]?.advance_tax_percent)) {
      advance_tax = piTaxFixed ? (Number(newRow[index].advance_tax) || 0) : handleAdvanceTaxItem(index);
    }
    if (newRow !== null && (newRow[index].discount_percent || newRow[index].discount)) {
      discount = piDiscountFixed ? (Number(newRow[index].discount) || 0) : handleDiscountItem(index);
    } 
    return roundOffStock(
      rate * qty +  tax + advance_tax - discount
    );
  };

  // discount
  const handleDiscountItem = (index) => {
    let discount = 0;
    let rate = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }

    if (newRow !== null && newRow[index].discount_percent !== "") {
      discount = parseFloat(newRow[index].discount_percent);
    }
    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return roundOffStock(rate * qty * (discount / 100));
  };

  const handleDiscounPercent = (index) => {
    let discount = 0;
    let rate = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }

    if (newRow !== null && newRow[index].discount !== "") {
      discount = parseFloat(newRow[index].discount);
    }
    return rate && qty ? roundOffStock((discount / (rate * qty)) * 100) : 0;
  };

  const handleTaxItem = (index) => {
    let tax = 0;
    let rate = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }

    if (newRow !== null && newRow[index].tax_percent !== "") {
      tax = parseFloat(newRow[index].tax_percent);
    }

    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return roundOffStock(rate * qty * (tax / 100));
  };

  const handleTaxPercent = (index) => {
    let tax = 0;
    let rate = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }

    if (newRow !== null && newRow[index].tax !== "") {
      tax = parseFloat(newRow[index].tax);
    }

    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return rate && qty ? roundOffStock((tax / (rate * qty)) * 100) : 0;
  };

  const handleDisAmount = () => {
    let discount = 0;
    if (newRow !== null && newRow.length>0) {
      newRow.map((item) => {
        if(piDiscountFixed){
          if(item.discount){
            discount = discount + Number(item.discount);
          }
        }else{
          if (item.discount_percent) {
            discount = discount +
              item.rate *
                item.qty *
                (item.discount_percent / 100);
          }
        }
      });
    }   
    return roundOffStock(discount);
  };

  const handleTaxAmount = () => {
    let tax = 0;
    if (newRow !== null && newRow.length>0) {
      newRow.map((item) => {
        if(piTaxFixed){
          if(item?.tax){
            tax = tax + Number(item.tax);
          }
        }else{
          if (item.tax_percent) {
            tax = tax +
              item.rate * item.qty *
              (item.tax_percent / 100);
          }
        }
      });
    }
    return roundOffStock(tax);
  };

  const handleAdvanceTaxItem = (index) => {
    let advance_tax = 0;
    let rate = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }

    if (newRow !== null && newRow[index].advance_tax_percent !== "") {
      advance_tax = parseFloat(newRow[index].advance_tax_percent);
    }

    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return roundOffStock(rate * qty * (advance_tax / 100));
  };

  const handleAdvanceTaxPercent = (index) => {
    let advance_tax = 0;
    let rate = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }

    if (newRow !== null && newRow[index].advance_tax !== "") {
      advance_tax = parseFloat(newRow[index].advance_tax);
    }

    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return rate && qty ? roundOffStock((advance_tax / (rate * qty)) * 100) : 0;
  };

  const handleAdvanceTaxAmount = () => {
    let advance_tax = 0;
    if (newRow !== null && newRow.length>0) {
      newRow.map((item) => {
        if(piTaxFixed){
          if(item?.advance_tax){
            advance_tax = advance_tax + Number(item.advance_tax);
          }
        }else{
          if (item.advance_tax_percent) {
            advance_tax = advance_tax +
              item.rate * item.qty *
              (item.advance_tax_percent / 100);
          }
        }
      });
    }
    return roundOffStock(advance_tax);
  };

  // total amount
  const handleAmount = () => {
    let total = 0;
    if (newRow !== null && newRow.length>0) {
      newRow.map((item) => {        
        if (
          parseFloat(item.qty) && parseFloat(item.rate)
        ) {
          total = total +  parseFloat(item.qty) * parseFloat(item.rate);
        }
      });
    }
    return roundOffStock(total);
  };

  //total
  const handleGetTotal = () => {
    let total = 0;
    let tax = 0;
    let advance_tax = 0;
    let discount = 0;
    if (newRow !== null && newRow.length>0) {
      newRow.map((item) => {
        tax = 0;
        advance_tax = 0;
        discount = 0;
        if(piTaxFixed){
          if(item.tax){
            tax = Number(item.tax);
          }
        }else{
          if (item.tax_percent) {
            tax = item.rate *
              item.qty *
              (item.tax_percent / 100);
          }
        }
        if(piDiscountFixed){
          if (item.discount) {
            discount = Number(item.discount);
          }
        }else{
          if (item.discount_percent) {
            discount = item.rate *
            item.qty * (item.discount_percent / 100);
          }
        }
        if(piTaxFixed){
          if(item.advance_tax){
            advance_tax = Number(item.advance_tax);
          }
        }else{
          if (item.advance_tax_percent) {
            advance_tax = item.rate * item.qty * (item.advance_tax_percent / 100);
          }
        }
        if (
          parseFloat(item.qty) && parseFloat(item.rate)
        ) {          
          total =
            total + (item.qty * item.rate) + tax + advance_tax - discount;
        }
      });
    }
    return roundOffStock(total);
  };

  //subtotal
  const handleGetAmount = (index) => {
    let qty = 0;
    let rate = 0;
    if (newRow !== null && newRow[index].qty !== "") {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return roundOffStock(rate * qty);
  };

  //set each item qty
  const handleItemQty = (index,e) => {
    newRow[index].qty=e.target.value;
    setNewRow([...newRow]);
  };

  //set each item qty
  const handleItemRate = (index,e) => {
    newRow[index].rate=e.target.value;
    setNewRow([...newRow]);
  };

   //discount and tax
   const handleSetRow = (index,e, key) => {
    newRow[index][key]=e.target.value;
    setNewRow([...newRow]);
  };

  //handle Set branch hook
  const handleSetBranch = (branch) => {
    if(newItem.supplier && newItem.is_ref_no && branch){
      getGRNItem(branch, newItem.supplier)
    }
    setNewItem({ ...newItem, branch });
  };

  const handleCheckRef=()=>{
    setNewItem({...newItem, is_ref_no: newItem.is_ref_no ? 0 : 1})
    if(!newItem.is_ref_no){
      setNewRow([]);
      if(newItem.branch && newItem.supplier){
        getGRNItem(newItem.branch, newItem.supplier)
      }
    }
  }

  //get supplier items
  const getIngredientSupplier = async(id) =>{
    const url = BASE_URL + "/settings/edit-supplier/" + id
    try{
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      return res.data;
    }catch(err){
      toast.error(
        `${_t(t("Failed to fetch supplier items"))}`,{
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }

  //handle Set supplier hook
  const handleSetSupplier = async(supplier) => {
    setNewItem({ ...newItem, supplier, ref_doc_identity: null });
    if(newItem.is_ref_no === 0){
      const supplierItems = await getIngredientSupplier(supplier?.id);
      if(supplierItems?.ingredient_items && supplierItems.ingredient_items?.length){
        const items = supplierItems.ingredient_items.map((item,index)=>{
          const units = [item.base_unit, item.default_unit];
          let maxLimit = "";
          if(newItem.branch?.max_pi_qty_check){
            maxLimit = ingredientLimitCheck?.igs?.[newItem.branch?.id]?.[item.id]?.max_limit;
          }
          return {
            item_name: item,
            ref_doc_identity: "",
            qty:"",
            max_qty: newItem.branch?.max_pi_qty_check && maxLimit ? (maxLimit ?? 0) : "",
            unit:item.default_unit ?? "",
            item_units:units,
            rate:"", 
            amount:"",         
            discount_percent:"",
            discount:0,
            base_unit: item?.unit_id,
            tax_percent:"",
            tax:0, 
            advance_tax_percent:"",
            advance_tax:0,
            total:"",
            base_qty:"",
            conversion_qty:item.default_unit?.qty ?? ""
          }
        });
        setNewRow([...items]);
      }else if(newRow?.length){
        setNewRow([]);
      }
    }else{
      if(newItem.is_ref_no){
        setNewRow([]);
      }
      if(supplier && newItem?.branch){
        getGRNItem(newItem.branch,supplier)
      }
    }
  };

  //post req of food item add
  const ingredientItemAxios = async () => {    
    let date =
      new Date(purchaseDate).getFullYear() +
      "-" +
      (new Date(purchaseDate).getMonth() + 1) +
      "-" +
      new Date(purchaseDate).getDate();

    if (!validateItemsProperty(newRow, "rate", _t(t("Price cannot be zero or empty")))) {
      return;
    }

    let slugArray=[];
    newRow.map((newIngredientItem,index) => {
      if(newIngredientItem.item_name === "" || newIngredientItem.unit===""){
        toast.error(`${_t(t("Please select all dropdowns"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        
      }
      else{
        slugArray.push({
          grn_detail_id: (newIngredientItem?.id && newItem.ref_doc_identity?.document_identity) ? newIngredientItem?.id : 0,
          ref_doc_identity: newIngredientItem?.ref_doc_identity || "",
          qty: parseFloat(newIngredientItem.qty),
          price: parseFloat(newIngredientItem.rate),
          item_id: newIngredientItem.isEdit ? newIngredientItem.item_id : newIngredientItem.item_name.id,
          item_name: newIngredientItem.isEdit ? newIngredientItem.item_name : newIngredientItem.item_name.name,          
          unit_id: newIngredientItem.isEdit ? newIngredientItem.unitId : newIngredientItem.unit.id,
          unit_name: newIngredientItem.isEdit ? newIngredientItem.unit : newIngredientItem.unit.name,
          amount: handleGetAmount(index),
          discount_percent: piDiscountFixed ? handleDiscounPercent(index) : (newIngredientItem.discount_percent !== "" ? parseFloat(newIngredientItem.discount_percent) : 0),
          discount: piDiscountFixed ? (newIngredientItem.discount || 0) : handleDiscountItem(index),
          tax_percent: piTaxFixed ? handleTaxPercent(index) : (newIngredientItem.tax_percent !== "" ? parseFloat(newIngredientItem.tax_percent) : 0),
          tax: piTaxFixed ? (newIngredientItem.tax || 0) : handleTaxItem(index),
          advance_tax_percent: piTaxFixed ? handleAdvanceTaxPercent(index) : (newIngredientItem.advance_tax_percent !== "" ? parseFloat(newIngredientItem.advance_tax_percent) : 0),
          advance_tax: piTaxFixed ? (newIngredientItem.advance_tax || 0) : handleAdvanceTaxItem(index),
          total: handleGetSubTotal(index),
          base_unit: newIngredientItem.base_unit,
          base_qty: calBaseQty(index),
          conversion_qty: parseFloat(newIngredientItem.conversion_qty),
          base_price: calBasePrice(index)
        });
      }
      });

    // let formData = {
    //   invoice_number: newItem.invoice,
    //   purchase_id:params.id,
    //   branch_id: newItem.branch.id,
    //   supplier_id: newItem.supplier.id,   
    //   ref_doc_identity: newItem.ref_doc_identity?.document_identity || "",     
    //   purchase_date: date,
    //   desc: newItem.description,
    //   pi_document: newItem.document,
    //   item: slugArray,
    //   payment_type: newItem.paymentType,
    //   credit_limit_days: newItem.credit_limit_days,
    //   manual_invoice_no: newItem.manual_invoice_no,
    //   transportation: (newItem.transportation || 0),
    //   net_amount: handleGetTotal() + (Number(newItem.transportation) || 0),
    //   total_bill: handleGetTotal(),
    //   total_amount: handleAmount(),
    //   total_tax: handleTaxAmount(),
    //   total_discount: handleDisAmount(),
    // };

    const formData = new FormData();
    formData.append("invoice_number",newItem.invoice);
    formData.append("purchase_id",params.id);
    formData.append("branch_id",newItem.branch.id);
    formData.append("supplier_id",newItem.supplier.id);
    formData.append("ref_doc_identity",newItem.ref_doc_identity?.document_identity || "");
    formData.append("purchase_date",date);
    formData.append("desc",newItem.description);
    formData.append("pi_document",newItem.document);
    formData.append("item",JSON.stringify(slugArray));
    formData.append("payment_type",newItem.paymentType);
    formData.append("credit_limit_days",newItem.credit_limit_days);
    formData.append("manual_invoice_no",newItem.manual_invoice_no);
    formData.append("transportation",(newItem.transportation || 0));
    formData.append("net_amount",handleGetTotal() + (Number(newItem.transportation) || 0));
    formData.append("total_bill",handleGetTotal());
    formData.append("total_amount",handleAmount());
    formData.append("total_tax",handleTaxAmount());
    formData.append("total_advance_tax",handleAdvanceTaxAmount());
    formData.append("total_discount",handleDisAmount());

    if(newRow.length === slugArray.length){
      setLoading(true);
      const endPoint = duplicate ? "/settings/new-ingredient_purchase" : "/settings/update-ingredient_purchase";
      const url = BASE_URL + endPoint;
      
    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setLoading(false);
      toast.success(`${_t(t("Purchase invoice has been updated"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      history.push("/dashboard/manage/stock/purchase-invoice");
    } catch (error) {
      console.log("check error==>",error);
      setLoading(false);
      if(customError(error)){
        return
      }
      toast.error(`${_t(t("Please try again later"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newItem.branch !== null &&
      newItem.supplier !== null &&
      newItem.invoice !== null &&
      newItem.paymentType !== null &&
      purchaseDate !== null
    ) {
      if(newRow.length > 0){
        ingredientItemAxios();
      }
      else{
        toast.error(`${_t(t("Please add invoices"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    } else {
      toast.error(`${_t(t("Please fill all the required fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  return (
  <>
      <Helmet>
        <title>{_t(t(`${duplicate ? "Add Purchase" : "Edit Purchase"}`))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${dataPaginating && "loading"}`}></div>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t(`${ duplicate ? "Add Purchase Invoice" : "Edit Purchase Invoice"}`))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>

                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 mb-5 table-text"
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="col-12">

                            <div className="row">
                              <div className="form-group col-3 mt-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="invoice"
                                    className="control-label"
                                  >
                                    {_t(t("Invoice"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control table-text"
                                    id="invoice"
                                    name="invoice"
                                    onChange={handleChange}
                                    value={newItem.invoice}
                                    placeholder="Auto no"
                                    required
                                  />
                                </div>
                              </div>

                              <div className="form-group col-3 text-right mt-3">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="purchaseDate"
                                    className="control-label"
                                  >
                                    {_t(t("Purchase Date"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <DatePicker
                                    minDate={piBackDate && authUserInfo?.details?.user_type !== "superAdmin" && new Date()}
                                    disabled={piBackDate}
                                    selected={purchaseDate}
                                    onChange={(date) => setPurchaseDate(date)}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control table-text"
                                    placeholderText={_t(t("Purchase date"))}
                                    shouldCloseOnSelect={false}
                                  />
                                </div>
                              </div>

                              <div className="form-group mt-3 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="paymentType"
                                    className="control-label"
                                  >
                                    {_t(t("Payment Type"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div
                                  className="mb-2 d-flex align-items-center"
                                  style={{ height: "2rem"}}
                                >
                                  <div className="col-6 d-flex align-items-center">
                                    <input
                                      style={{fontSize:"1.2rem"}}
                                      type="radio"
                                      className="form-check-input pointer-cursor table-text"
                                      id="cash"
                                      name="paymentType"
                                      value="cash"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      checked={
                                        newItem.paymentType === "cash" ? 1 : 0
                                      }
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2 mt-2"
                                      htmlFor="cash"
                                      style={{fontSize:"0.9rem"}}
                                    >
                                      {_t(t("Cash"))}
                                    </label>
                                  </div>
                                  <div className="col-6 d-flex align-items-center">
                                    <input
                                      style={{fontSize:"1.2rem"}}
                                      type="radio"
                                      className="form-check-input pointer-cursor table-text"
                                      id="credit"
                                      name="paymentType"
                                      value="credit"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      checked={
                                        newItem.paymentType === "credit" ? 1 : 0
                                      }
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2 mt-2"
                                      htmlFor="credit"
                                      style={{fontSize:"0.9rem"}}
                                    >
                                      {_t(t("Credit"))}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className="form-group col-3 text-right mt-3">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="is_ref_no"
                                    className="control-label"
                                  >
                                    {_t(t("Ref No."))}
                                  </label>
                                </div>
                                <div className="mb-2 float-left">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="is_ref_no"
                                    name="is_ref_no"
                                    onChange={()=> handleCheckRef()}
                                    checked={newItem.is_ref_no}
                                  />
                                </div>
                              </div> 

                            </div>

                            <div className="row">                              
                              <div className="form-group mt-2 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="branch"
                                    className="control-label"
                                  >
                                    {_t(t("Branch"))}
                                    <span className="text-danger">*</span>                                      
                                  </label>
                                </div>
                                <Select
                                  options={branchForSearch ? branchForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newItem.branch || ""}
                                  isDisabled={params.id}
                                  classNamePrefix="select"
                                  onChange={handleSetBranch}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={
                                    _t(t("Please select a branch")) + ".."
                                  }
                                />
                              </div>  

                              <div className="form-group mt-2 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="branch"
                                    className="control-label"
                                  >
                                    {_t(t("Supplier"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={supplierForSearch ? supplierForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newItem.supplier || ""}
                                  isDisabled={params.id}
                                  classNamePrefix="select"
                                  onChange={handleSetSupplier}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={
                                    _t(t("Please select a supplier")) + ".."
                                  }
                                />
                              </div> 

                              <div className="form-group mt-2 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="manual_inv_no"
                                    className="control-label"
                                  >
                                    {_t(t("GRN Ref No"))}
                                  </label>
                                </div>

                                <div className="mb-2">
                                  <Select
                                    options={GRNDetail}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.document_identity}
                                    getOptionValue={(option) => option.id}
                                    value={newItem.ref_doc_identity || ""}
                                    classNamePrefix="select table-text"
                                    onChange={(option)=>setGRNItem(option)}
                                    maxMenuHeight="200px"
                                    isClearable
                                    placeholder={
                                      _t(t("Select GRN Ref")) + ".."
                                    }
                                    styles={customStyle}
                                    isDisabled={!newItem.supplier || !newItem.branch || !newItem.is_ref_no || !duplicate}
                                  />
                                </div> 
                              </div>  

                              <div className="form-group mt-2 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="manual_inv_no"
                                    className="control-label"
                                  >
                                    {_t(t("Manual Invoice No"))}
                                  </label>
                                </div>

                                <div className="mb-2">
                                  <input
                                    type="text"
                                    className="form-control table-text"
                                    id="manual_inv_no"
                                    name="manual_invoice_no"
                                    onChange={handleChange}
                                    value={newItem.manual_invoice_no}
                                    placeholder="Invoice no"
                                  />
                                </div> 
                              </div>
                            
                            </div> 
                            
                            <div className="row">

                              <div className="form-group mt-2 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="credit_limit_days"
                                    className="control-label"
                                  >
                                    {_t(t("Credit Limit Days"))}
                                  </label>

                                </div>
                                <div className="mb-2">
                                  <input
                                    type="text"
                                    className="form-control table-text"
                                    id="credit_limit_days"
                                    name="credit_limit_days"
                                    onChange={handleChange}
                                    value={newItem.credit_limit_days}
                                    placeholder="Credit limit days"
                                  />
                                </div> 
                              </div>

                              <div className="form-group mt-2 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="doc"
                                    className="form-label d-block"
                                  >
                                    {_t(t("Attach Document"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    accept="image/*,.pdf,.jpg,.jpeg,.png,.mp4"
                                    type="file"
                                    className="form-control sm-text d-none"
                                    id="doc"
                                    name="document"
                                    onChange={handleItemImage}
                                  />
                                  <label htmlFor="doc" className="image-btn">
                                    Choose File
                                  </label>
                                  {newItem?.document && (
                                    <>
                                      <span className="text-truncate d-inline-block" style={{maxWidth:"5rem", marginBottom:"-0.35rem"}}>
                                        {newItem.document?.name ?? newItem?.document}
                                      </span>
                                      <button type="button" onClick={(e)=>setNewItem({...newItem, document: ""})} className="btn-close ml-2 cursor-pointer" aria-label="Close"></button>
                                    </>
                                  )}
                                </div>
                              </div>

                              <div className="form-group mt-2 col-6">
                                <div className="mb-2">
                                  <label
                                    htmlFor="description"
                                    className="control-label"
                                  >
                                    {_t(t("Description"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <textarea
                                    type="text"
                                    className="form-control table-text"
                                    id="description"
                                    name="description"
                                    onChange={handleChange}
                                    value={newItem.description}
                                    placeholder="Short description"
                                  />
                                </div>
                              </div>
                            </div>
                            
                            <div className={`table-responsive mt-3 pr-1 `}
                              style={{maxHeight:"23rem",overflow: "auto"}}>
                                <table className="table table-bordered-sm table-hover">
                                  <thead className="align-middle">                                    
                                    <tr>
                                    {newRow.length==0 ?<th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span className="t-mr-10" onClick={()=>addNewRow()}>
                                        <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                      </span>
                                    </th>:<th style={{borderBottomColor:"lightgray"}}></th>}
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border table-Child"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Item Name"))}
                                        </span>
                                      </th> 

                                      {
                                        newItem.branch?.max_pi_qty_check ? (
                                          <th
                                            scope="col"
                                            className="table-text text-capitalize align-middle text-center border-1 border"
                                          >
                                            <span style={{fontWeight:500}}>
                                            {_t(t("Max Qty"))}
                                            </span>
                                          </th>
                                        ) : ""
                                      }                                    
                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Qty"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Unit"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Rate"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Amount"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{minWidth:'130px'}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Discount Percent"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{minWidth:'130px'}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Discount Amount"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Tax Percent"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Tax Amount"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Advance Tax Percent"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Advance Tax Amount"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Total"))}
                                        </span>
                                      </th>
                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border d-none"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Base unit"))}
                                        </span>
                                      </th>
                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Base qty"))}
                                        </span>
                                      </th>
                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{minWidth:"9rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Conversion unit"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{minWidth:"9rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Base price"))}
                                        </span>
                                      </th>
                                      {newRow.length>0 && <th style={{borderBottomColor:"lightgray",minWidth:"60px"}}></th>}
                                    </tr>
                                  </thead>
                                  {newRow && newRow.length>0 ?
                                  <tbody className="align-middle">
                                    {newRow.map(
                                      (ingredientItem, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{minWidth:"60px"}}>
                                              {index==(newRow.length-1) && <span className="t-mr-10" onClick={()=>addNewRow()}>
                                            <i className="fa fa-plus-circle btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                            </span>}&nbsp;
                                            <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} 
                                            onClick={()=>{delRow(index)}}
                                            ></i>
                                            </td>
                                            <td className="table-text text-capitalize align-middle text-center">
                                            {ingredientItem.isEdit ?
                                              <input
                                              readOnly
                                              type="text"
                                              className={`form-control text-center table-Input table-text`}
                                              value={ingredientItem.item_name || ""}
                                              />
                                              : 
                                              <Select
                                                options={ingredientItemNonPurchase !== null ? ingredientItemNonPurchase : []}
                                                components={makeAnimated()}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}
                                                classNamePrefix="select"
                                                onChange={(e)=>handleSetItems(index,e)}
                                                maxMenuHeight="12.8rem"                                                
                                                value={ingredientItem.item_name}
                                                styles={customStyle}
                                                isMenuOpen={true}
                                                menuPlacement={index >= 1 ? "top" : "bottom"} 
                                                menuPosition="fixed"
                                                className="bank-table-input"                                              
                                                placeholder={
                                                _t(t("Please select items")) + ".."
                                                }                                                
                                              />}
                                            </td>

                                            {
                                              newItem.branch?.max_pi_qty_check ? (
                                                <td className="table-text text-capitalize align-middle text-center">
                                                  {ingredientItem?.max_qty < 0 ? 0 : (ingredientItem?.max_qty ?? "")}
                                                </td>
                                              ) : ""
                                            }
                                          
                                            <td className="table-text text-capitalize align-middle text-center">
                                              <input
                                                type="number"
                                                step={qtyAmountPoints()}
                                                min="0"
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control text-center table-Input table-text"
                                                id={ingredientItem.id}
                                                name={ingredientItem.id}
                                                onChange={(e)=>handleItemQty(index,e)}
                                                value={                                                    
                                                  ingredientItem.qty || ""
                                                }
                                                max={ingredientItem?.max_qty ? ingredientItem?.max_qty : undefined}
                                                placeholder="Qty"
                                                required                                                  
                                              />
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center">
                                              {ingredientItem.isEdit ?
                                              <input
                                                readOnly
                                                type="text"
                                                className={`form-control text-center table-Input table-text`}
                                                value={ingredientItem.unit || ""}
                                              /> 
                                              :                                                
                                              <Select
                                                menuPosition="fixed"
                                                menuPlacement={index >= 1 ? "top" : "bottom"} 
                                                options={ingredientItem.item_units ? ingredientItem.item_units : []}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}
                                                value={ingredientItem.unit}
                                                classNamePrefix="select"
                                                onChange={(e)=>handleSetUnit(index,e)}
                                                className="bank-table-input"
                                                maxMenuHeight="200px"
                                                styles={customStyle}                                                  
                                                placeholder={
                                                _t(t("please select unit")) + ".."
                                                }            
                                                isDisabled={ingredientItem.item_units?false:true}                                        
                                              />}
                                            </td>
                                            <td className="table-text text-capitalize align-middle text-center">
                                              <input
                                                type="number"
                                                step={qtyAmountPoints()}
                                                min="0"
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control text-center table-Input table-text"
                                                id={ingredientItem.id}
                                                name={ingredientItem.id}
                                                onChange={(e)=>handleItemRate(index,e)}
                                                value={                                                  
                                                  ingredientItem.rate ?? ""
                                                }
                                                placeholder="Price"
                                                required                                                 
                                              />
                                            </td>
                                            <td className="table-text align-middle text-center">
                                              {formatPrice(
                                                handleGetAmount(                                                    
                                                  index
                                                )
                                              )}
                                            </td>

                                            {
                                              piDiscountFixed ? (
                                                <>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    {formatPrice(
                                                      handleDiscounPercent(                                                    
                                                        index
                                                      )
                                                    )}
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className={`form-control text-center table-Input table-text ${                                                    
                                                        ""
                                                      }`}
                                                      id={ingredientItem.id}
                                                      name={ingredientItem.id}
                                                      onChange={(e)=>handleSetRow(index,e,"discount")}
                                                      value={                                                    
                                                        ingredientItem.discount || ""
                                                      }
                                                      placeholder="Discount"
                                                    />
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className={`form-control text-center table-Input table-text ${                                                  
                                                        ""
                                                      }`}
                                                      id={ingredientItem.id}
                                                      name={ingredientItem.id}
                                                      onChange={(e)=>handleSetRow(index,e,"discount_percent")}
                                                      value={                                                    
                                                        ingredientItem.discount_percent || ""
                                                      }
                                                      placeholder="Discount"
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    {formatPrice(
                                                      handleDiscountItem(                                                    
                                                        index
                                                      )
                                                    )}
                                                  </td>
                                                </>
                                              )
                                            }

                                            {piTaxFixed ? (
                                                <>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    {
                                                    formatPrice(handleTaxPercent(index))
                                                    }
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className={`form-control text-center table-Input table-text ${                                                    
                                                        ""
                                                      }`}
                                                      id={ingredientItem.id}
                                                      name={ingredientItem.id}
                                                      onChange={(e)=>handleSetRow(index,e,"tax")}
                                                      value={                                                    
                                                        ingredientItem.tax || ""
                                                      }
                                                      placeholder="Tax"
                                                    />
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className={`form-control text-center table-Input table-text ${                                                    
                                                        ""
                                                      }`}
                                                      id={ingredientItem.id}
                                                      name={ingredientItem.id}
                                                      onChange={(e)=>handleSetRow(index,e,"tax_percent")}
                                                      value={                                                    
                                                        ingredientItem.tax_percent || ""
                                                      }
                                                      placeholder="Tax"
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    {formatPrice(
                                                      handleTaxItem(                                                    
                                                        index
                                                      )
                                                    )}
                                                  </td>
                                                </>
                                              )}

                                              {piTaxFixed ? (
                                                <>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    {
                                                    formatPrice(handleAdvanceTaxPercent(index))
                                                    }
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className={`form-control text-center table-Input table-text ${                                                    
                                                        ""
                                                      }`}
                                                      id={`adv_tax_${index}`}
                                                      name={`adv_tax_${index}`}
                                                      onChange={(e)=>handleSetRow(index,e,"advance_tax")}
                                                      value={                                                    
                                                        ingredientItem.advance_tax || ""
                                                      }
                                                      placeholder="Adv Tax"
                                                    />
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className={`form-control text-center table-Input table-text ${                                                    
                                                        ""
                                                      }`}
                                                      id={`adv_tax_percent_${index}`}
                                                      name={`adv_tax_percent_${index}`}
                                                      onChange={(e)=>handleSetRow(index,e,"advance_tax_percent")}
                                                      value={                                                    
                                                        ingredientItem.advance_tax_percent || ""
                                                      }
                                                      placeholder="Adv Tax"
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    {formatPrice(
                                                      handleAdvanceTaxItem(                                                    
                                                        index
                                                      )
                                                    )}
                                                  </td>
                                                </>

                                              )
                                            }

                                            <td className="table-text text-capitalize align-middle text-center">
                                              {formatPrice(
                                                handleGetSubTotal(                                                    
                                                  index
                                                )
                                              )}
                                            </td>

                                            {/* hidden columns */}
                                            
                                            <td className="table-text align-middle text-center d-none">
                                              {ingredientItem.base_unit}
                                            </td> 
                                            
                                            <td className="table-text align-middle text-center">                                                
                                              {formatPrice(calBaseQty(index))}
                                            </td>
                                            
                                            <td className="table-text align-middle text-center">
                                              {ingredientItem.conversion_qty}
                                            </td> 

                                            <td className="table-text align-middle text-center">
                                              {formatPrice(calBasePrice(index))}
                                            </td> 
                                            
                                            <td className="table-text text-capitalize align-middle text-center" style={{minWidth:"60px"}}>
                                              <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} onClick={()=>{delRow(index)}}></i>&nbsp;
                                              {index==(newRow.length-1) && <span className="t-mr-10" onClick={()=>addNewRow()}>
                                                <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                              </span>}                                             
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                  :null}
                                  {newRow && newRow.length>0 ?
                                  <tfoot className="align-middle">
                                    <tr>
                                      <th
                                        scope="col"
                                        colSpan="1"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        scope="col"
                                        colSpan="3"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                            {_t(t("Total"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {formatPrice(handleAmount())}
                                        </span>
                                      </th>
                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {formatPrice(handleDisAmount())}
                                        </span>
                                      </th>
                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {formatPrice(handleTaxAmount())}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {formatPrice(handleAdvanceTaxAmount())}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>                                            
                                          {formatPrice(handleGetTotal())}
                                        </span>
                                      </th>

                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      
                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      
                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      
                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                    </tr>
                                    <tr>
                                      <th colSpan="1"></th>
                                      <th colSpan="10"></th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {_t(t("Transport"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <input
                                          type="number"
                                          step={qtyAmountPoints()}
                                          min="0"
                                          onKeyDown={(evt) =>
                                            ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                            evt.preventDefault()
                                          }
                                          onWheel={(e) => e.target.blur()}
                                          className="form-control text-center table-Input table-text"
                                          id="transportation"
                                          name="transportation"
                                          onChange={(e)=>handleChange(e)}
                                          value={                                                   
                                            newItem.transportation || ""
                                          }
                                        />
                                        </th>
                                        <th colSpan="3"></th>
                                        <th colSpan="1"></th>
                                    </tr>
                                    <tr>
                                      <th colSpan="1"></th>
                                      <th colSpan="10"></th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {_t(t("Net Total"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>                                            
                                          {formatPrice(handleGetTotal() + (Number(newItem.transportation) || 0))}
                                        </span>
                                      </th>
                                      <th colSpan="3"></th>
                                      <th colSpan="1"></th>
                                    </tr>
                                  </tfoot>
                                  :null}
                                </table>
                            </div>

                            <div className="form-group mt-4 pb-2">
                              {/* <div className="col-lg-12">
                                <button
                                  className="btn btn-primary px-5 rounded"
                                  type="submit"                                  
                                >
                                  {_t(t("Save"))}
                                </button>
                                <button
                                  className="btn btn-primary px-5 mx-2 rounded"
                                  onClick={() =>
                                    history.push(
                                      "/dashboard/manage/stock/purchase-invoice"
                                    )
                                  }
                                >
                                  {_t(t("Back"))}
                                </button>
                              </div> */}
                              <div className="d-flex justify-content-end align-items-center">
                                <div className="col-3 d-flex justify-content-end">
                                  <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={()=>(history.push("/dashboard/manage/stock/purchase-invoice"))}
                                  //   data-dismiss="modal"
                                  >
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                  </button>
                                  <button
                                  disabled={loading}
                                  type="submit"
                                  className="btn btn-primary rounded"
                                  >
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i> {_t(t(`${duplicate ? "Save" : "Update"}`))}
                                  </button>                                                    
                                </div>                                                    
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default IngredientPurchaseEdit;
